<div class="title">{{ "measurement.title" | translate }}</div>

<a class="change-unit" (click)="changeUnitSystem()">
  <span>{{ "measurement.changeUnit" | translate }}</span>
  <span>&nbsp;</span>
  {{ "measurement." + getChangeUnitLabel() | translate }}
</a>
<div class="results">
  @for (measure of measurements(); track $index) {
    @let selectedMeasurement = selectedMeasurement$();
    @let isAreaBased = measure.type === MeasurementType.AREA || measure.type === MeasurementType.TIP_DEFECT;
    @let measurementValue = isAreaBased ? measure.parameters.area : measure.parameters.length;
    @let unitType = isAreaBased ? "area" : "length";

    <div class="measure" [class.selected]="selectedMeasurement?.measureId === measure.measureId" (click)="selectMeasurement(measure)">
      <div class="measure-info">
        <span class="label">{{ "measurement." + measure.type | translate }}:</span>
        <div class="value">
          {{ measurementValue | convert: unitSystem() : (isAreaBased ? "area" : null) | number: precision }}
          <span class="unit">{{ getUnitLabel(unitType) }}</span>
        </div>
      </div>
      @if (selectedMeasurement?.measureId === measure.measureId) {
        <evc-button [textContent]="'remove'" [importance]="'secondary'" size="small" (click)="removeMeasure(measure)"></evc-button>
      }
    </div>
  }
</div>
